import Vue from 'vue'
import VueI18n from 'vue-i18n'
import globalMessages from './global-messages'

// Install Vue I18n
Vue.use(VueI18n)

// Create VueI18n instance
export const i18n = new VueI18n({
  locale: 'en',
  messages: globalMessages,
})
